<template>
  <div class="page-content">
    <div class="card">
      <div class="card-header">
        <h1 class="card-header-title small">{{ content.title }}</h1>
        <p class="card-header-description">{{ content.description }}</p>
        <div>
          <img :src="imageUrl" alt="Image" class="card-image medium" />
          <p class="card-header-description">
            <strong>Dr Corrie Ackland,</strong> Director and Principal Clinical
            Psychologist at Sydney Phobia Clinic
          </p>
        </div>
      </div>

      <CustomIcon
        :name="content.image"
        class="card-image small-bottom-margin"
      />
      <p class="card-header-description">
        oVRcome's team of Clinical Psychologists
      </p>

      <CustomButton variation="primary" :onClick="action"
        >Continue</CustomButton
      >
    </div>
  </div>
</template>
<script>
import CustomIcon from "@/components/CustomIcon.vue";
import CustomButton from "@/components/CustomButton.vue";
export default {
  data() {
    return {
      imageUrl: require("@/assets/icons/corrie.png"),
    };
  },
  components: {
    CustomIcon,
    CustomButton,
  },
  props: {
    action: {
      type: Function,
      required: true,
    },
    content: {
      type: Object,
      required: true,
      default: () => ({
        content: String,
        description: String,
        image: String,
      }),
    },
  },
};
</script>
